module.exports = __webpack_public_path__ + "static/img/history.d8878b9b.png";